import { Link } from "wouter";
import { BRAND_LOGO_URL } from "@/lib/brand";
import { CATALOG_FILTERS, getCatalogFilterPath } from "@/lib/routes";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const supportLinks = [
    { label: "Market Value Guides", href: "/guides" },
    { label: "Help Center", href: "/support#help-center" },
    { label: "Contact Us", href: "/support#contact-us" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms of Service", href: "/terms-of-service" },
  ];

  return (
    <footer className="relative isolate z-10 overflow-hidden border-t border-border bg-background">
      <div className="container pt-8 pb-4 sm:pt-14 sm:pb-6">
        <h2 className="sr-only">Footer</h2>
        <div className="grid gap-7 xl:grid-cols-[minmax(0,1.2fr)_minmax(0,1.8fr)] xl:items-start xl:gap-10">
          {/* Brand */}
          <div className="max-w-md">
            <Link href="/" aria-label="Techfare home" className="mb-3 inline-flex shrink-0 items-center sm:mb-4">
              <span
                aria-hidden="true"
                className="brandmark-protected block h-8 w-[136px]"
                style={{ backgroundImage: `url("${BRAND_LOGO_URL}")` }}
              />
              <span className="sr-only">Techfare</span>
            </Link>
            <p className="text-sm leading-relaxed text-muted-foreground">
              The technology stock market. Track real-time market prices for the latest tech products.
            </p>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-border bg-muted/60 px-3 py-1.5 sm:mt-5">
              <span className="h-2 w-2 rounded-full bg-primary animate-pulse" />
              <span className="text-xs font-medium text-muted-foreground">Live market data</span>
            </div>
          </div>

          <div className="grid gap-x-6 gap-y-6 sm:gap-8 xl:grid-cols-[minmax(0,1.25fr)_minmax(0,0.95fr)]">
            {/* Markets */}
            <div>
              <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-foreground sm:mb-4">Markets</h3>
              <ul className="grid grid-cols-2 gap-x-6 gap-y-2 sm:gap-y-2.5">
                {CATALOG_FILTERS.map((filter) => (
                  <li key={filter.slug}>
                    <Link
                      href={getCatalogFilterPath(filter.slug)}
                      className="text-sm leading-5 text-muted-foreground transition-colors hover:text-primary sm:leading-6"
                    >
                      {filter.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div>
              <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-foreground sm:mb-4">Support</h3>
              <ul className="space-y-2 sm:space-y-2.5">
                {supportLinks.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-primary"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-7 flex flex-col gap-2.5 border-t border-border pt-4 sm:mt-10 sm:gap-4 sm:pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-muted-foreground">
            &copy;{currentYear} techfare LLC. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-muted-foreground">
            <span>Built for tracking fast-moving tech markets.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
